import "./App.css";
import { Fragment, useEffect, useRef, useState } from "react";
import PillButton from "./components/pillButton/PillButton";
import Section from "./components/section/Section";
import { InfoCard } from "./components/infoCard/InfoCard";
import CourseLocation from "./components/location/Location";
import FAQ from "./sections/FAQ/FAQ";
import SuggestionForm from "./sections/FAQ/SuggestionForm";
import Footer from "./sections/footer/Footer";
import "./index.css";
import BurgerMenu from "./components/burgerMenu/BurgerMenu";

function App() {
  const [showStickyNav, setShowStickyNav] = useState(false);
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  const handleScroll = (event: any, sectionId: string) => {
    event.preventDefault(); // Prevent default anchor link behavior
    const section = document.getElementById(sectionId);
    section?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  useEffect(() => {
    function handleScroll() {
      if (!sentinelRef.current) return;

      // Get the distance of sentinel from top of viewport
      const topOffset = sentinelRef.current.getBoundingClientRect().top;

      // If sentinel is at or above top (<= 0),
      // it means we've scrolled past it
      if (topOffset <= 0) {
        setShowStickyNav(true);
      } else {
        setShowStickyNav(false);
      }
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="h-full min-h-screen w-full">
      <Section id="Home" className="min-h-screen size-full">
        <Fragment>
          <div className="flex gap-6 pl-20 bg-white max-md:hidden">
            <a href="tel:+41764727563" className="">
              ✆: +41 76 472 75 63
            </a>
            <a href="mailto:kontakt@fahrschul-kurse.ch">
              📧: kontakt@fahrschul-kurse.ch
            </a>
          </div>
          <div
            className="relative bg-cover bg-top bg-no-repeat size-full min-h-screen flex flex-col"
            style={{
              backgroundImage:
                "url('/assets/images/businesspeople-talking-about-work-project.svg')",
            }}
          >
            <div className="linearGradientRectangle" />

            {/* <div className="h-30 w-30">
            <img
              src="/assets/images/businesspeople-talking-about-work-project.svg"
              alt="Logo"
              className="w-24 h-24"
            />
          </div> */}
            {/* <div className="sticky top-0 z-10 bg-dark-blue py-5">
            <div className="w-full flex justify-between">
              <div>logo</div>
              <div className="text-dark-blue">X</div>
            </div>
          </div> */}
            <div className="md:hidden">
              <BurgerMenu onHandleScroll={handleScroll} mode={"white"} />
            </div>
            <div className={`flex w-full px-10 max-md:hidden`}>
              <nav
                className={`relative flex bg-white rounded-[100px] mt-5 h-10 items-center justify-between w-full m-2 px-10`}
              >
                <ul>
                  <li>
                    <div className="flex justify-center">
                      <img
                        src={"/assets/logo/LOGOSVG.svg"}
                        alt="Learner Swiss Number"
                        className="size-48"
                      />
                    </div>
                  </li>
                </ul>
                <ul className="flex gap-2">
                  <li className="flex items-center">
                    <a
                      href="#Home"
                      onClick={(e) => handleScroll(e, "Home")}
                      className="px-3 py-1"
                    >
                      <p className="hover:border-b-2 hover:border-light-blue border-transparent box-border">
                        Startseite
                      </p>
                    </a>
                  </li>
                  <li className="flex items-center">
                    <a
                      href="#Register"
                      onClick={(e) => handleScroll(e, "Info")}
                      className="px-3 py-1"
                    >
                      <p className="hover:border-b-2 hover:border-b-light-blue border-transparent box-border">
                        Anmelden
                      </p>
                    </a>
                  </li>
                  <li className="flex items-center">
                    <a
                      href="#FAQ"
                      onClick={(e) => handleScroll(e, "Location")}
                      className="px-3 py-1"
                    >
                      <div className="hover:border-b-2 hover:border-b-light-blue border-transparent box-border">
                        Standort
                      </div>
                    </a>
                  </li>
                  <li className="flex items-center">
                    <a
                      href="#FAQ"
                      onClick={(e) => handleScroll(e, "FAQ")}
                      className="px-3 py-1"
                    >
                      <div className="hover:border-b-2 hover:border-b-light-blue border-transparent box-border">
                        FAQ
                      </div>
                    </a>
                  </li>
                  <li className="flex items-center">
                    <a
                      href="#ContactUs"
                      onClick={(e) => handleScroll(e, "ContactUs")}
                      className="px-3 py-1"
                    >
                      <div className="hover:border-b-2 hover:border-b-light-blue border-transparent box-border">
                        Kontakt
                      </div>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="relative text-white flex flex-col min-h-screen size-full justify-around -space-y-32 ">
              <div className="w-full font-title text-6xl flex justify-center text-center">
                <p className="w-full flex justify-center items-center max-w-[650px] ">
                  <img
                    src={"/assets/images/ilustrations/hero-page-logo.png"}
                    alt="Logo Hero"
                    className="size-[90%] max-md:size-[70%] bg-center"
                  />
                  {/* <img
                  src={"/assets/logo/logoFahr.svg"}
                  alt="Page Logo"
                  className="w-52 h-52"
                /> */}
                </p>
              </div>
              <div className="w-full font-content text-xl flex justify-center text-center">
                <p className="max-w-[560px]">
                  Unsere über 20jährige Erfahrung im Fahrschulwesen bietet Dir
                  eine gute Basis für Deine sichere Teilnahme im
                  Strassenverkehr. Wir erteilen die unten aufgeführten Kurse in
                  kleinen Gruppen und gemäss den neusten methodisch-didaktischen
                  Methoden.
                </p>
              </div>
              <div className="w-full flex justify-center ">
                <button onClick={(e) => handleScroll(e, "Info")}>
                  <PillButton
                    text={"Kurs wählen"}
                    className="py-4 lg:text-xl"
                  />
                </button>
              </div>
            </div>
          </div>
        </Fragment>
        {/* </div> */}
      </Section>
      <div className="size-full">
        {/* <div className="md:hidden"> */}
        <BurgerMenu onHandleScroll={handleScroll} showNavbar={showStickyNav} />
        {/* </div> */}
        <Section id="Info" className="">
          <div
            ref={sentinelRef}
            className="relative pt-20 pb-20 max-lg:pb-20 max-lg:pt-32 flex flex-col"
          >
            <div
              className="absolute size-full bg-blend-saturation inset-0 bg-top bg-contain bg-no-repeat max-lg:bg-repeat-y max-sm:bg-no-repeat"
              style={{
                backgroundImage:
                  "url('/assets/images/ilustrations/bg-above.png')",
                zIndex: -11,
              }}
            />
            {/* <img
              src="/assets/images/ilustrations/bg-above.png"
              className="absolute size-full bg-blend-saturation inset-0 object-top object-contain  bg-contain"
              style={{ zIndex: -11 }}
            /> */}
            <div className="relative">
              <div className="font-title text-dark-blue text-4xl -mt-2 w-full text-center">
                <p>Kurs auswählen und online anmelden</p>
              </div>
              <div className="flex flex-row-reverse gap-20 mx-20 mt-24 max-xl:flex-col-reverse max-xl:gap-10 max-sm:mx-6">
                <div className="size-full -mt-[7.5rem] max-xl:mt-0">
                  <img
                    src={"/assets/images/ilustrations/human-in-car.png"}
                    alt="Logo Guarantee"
                    className="h-52 w-[70%] px-3 -mb-16 relative -z-10 max-xl:-mb-20"
                  />
                  <InfoCard
                    type="vku"
                    title="Verkehrskunde-Kurs (VKU)"
                    logo="VKU"
                    content="Den Verkehrskunde-Kurs (VKU) kannst und musst Du erst nach bestandenen Theorieprüfung besuchen. Der VKU ist in der Schweiz obligatorisch und Voraussetzung für die Anmeldung zur Fahrprüfung. Der Verkehrskundeunterricht (VKU) umfasst insgesamt acht Stunden, die auf zwei Abende bzw. zwei Vormittage mit je vier Stunden aufgeteilt werden. Im ersten Teil vom Kurs lernst Du die Gefahren im Strassenverkehr vor der Entstehung richtig zu erkennen und erfolgreich zu bewältigen. Im zweiten Teil vom Kurs lernst Du wie Du den Zustand Deines Fahrzeugs regelmässig kontrollieren kannst. Die VKU-Kurse finden bei einer entspannten Atmosphäre am Abend oder am Wochenende statt. Hier werden Deine Fragen aus dem Fahrunterricht beantwortet und Du kannst Dich diesbezüglich mit den anderen Kursteilnehmer austauschen. Ein gültiger Lernfahrausweis ist die einzige Voraussetzung für die Teilnahme."
                    subContent="8 Lektionen, ab Fr. 140.- (all inclusive)"
                  />
                </div>
                <div className="font-title text-dark-blue text-3xl flex items-center justify-center animate-bounce-slow">
                  ODER
                </div>
                <div className="size-full">
                  <img
                    src={"/assets/images/ilustrations/human-aid.png"}
                    alt="Logo Guarantee"
                    className="h-80 -mb-10 -mt-40 max-[1145px]:-mt-24 max-xl:relative max-xl:-z-10 max-xl:-mb-40"
                  />
                  <InfoCard
                    type="plus"
                    title="Nothelferkurse"
                    logo="+"
                    content="Der Nothelferkurs ist in der Schweiz obligatorisch und ist Grundvoraussetzung für die Zulassung zur Theorieprüfung. Im Nothelferkurs lernst Du das richtige Handeln bei verschiedenen Notsituationen, welche im Strassenverkehr auftreten können. Für die sichere Teilnahme im Strassenverkehr gehören die Inhalte des Nothelferkurses zu den Grundlagenwissen. Darum ist dieser Kurs der erste Schritt zu Deinem Fahrausweis Kat. A oder Kat. B. Der Nothelferkurs umfasst insgesamt 10 Stunden und wird auf drei Abende oder am Samstag und Sonntag aufgeteilt. Nach absolviertem Nothelferkurs bekommst Du einem offiziell anerkannten Nothelferausweis."
                    subContent="10 Lektionen, Fr. 130.- (inkl. NH-Ausweis)"
                  />
                </div>
              </div>
            </div>
          </div>
        </Section>
        <Section id="Location" className="mt-20">
          <Fragment>
            <div className="font-title text-dark-blue text-4xl w-full text-center">
              <p>Unser Standort</p>
              <div className="mx-20 mt-10 max-sm:mx-5">
                <CourseLocation />
              </div>
            </div>
          </Fragment>
        </Section>
        <Section id="FAQ" className="mt-20">
          <Fragment>
            <div className="flex flex-col w-full h-full justify-around">
              <div className="w-full flex flex-col justify-center items-center text-center text-6xl max-md:text-6xl">
                <p className="max-w-[680px]  font-title  text-dark-blue">
                  Haeufig gestellte Fragen zum
                </p>
                <div className="font-title  text-light-blue">
                  <div className="max-sm:hidden">Nothelferkurs</div>
                  <div className="sm:hidden">Nothelfer-kurs</div> und
                  <span> VKU</span>
                </div>
              </div>
              {/* <div className="w-full font-content  text-dark-blue text-xl flex justify-center text-center mt-10">
              <p className="max-w-[680px]">
                Join our engaging and practical VKU and Red Cross courses in
                Winterthur, led by experienced and approachable driving
                instructors. Register online today and move one step closer to
                passing your driving test with confidence!
              </p>
            </div> */}
            </div>
            <div className="mt-16">
              <FAQ />
            </div>
            <div className="mt-10 max-sm:mt-5">
              <SuggestionForm />
            </div>
          </Fragment>
        </Section>
        <Section id="ContactUs" className="mt-20">
          <Fragment>
            <Footer />
          </Fragment>
        </Section>
      </div>
    </div>
  );
}

export default App;
